import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import { useStyle } from "./style";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";

export enum EBroadbandKeyError {
    DEFAULT = "error",
    UNAVAILABLE = "unavailable",
}

interface IBroadbandErrorContentProps {
    onRemove?: () => void;
    broadbandKeyTranslation?: EBroadbandKeyError;
    remove?: boolean;
}

export const BroadbandErrorContent = (props: IBroadbandErrorContentProps) => {
    const { onRemove, broadbandKeyTranslation = EBroadbandKeyError.DEFAULT, remove = true } = props;
    const { t } = useTranslation("cart");
    const { classes } = useStyle();

    const getTranslationKeys = (keyType: EBroadbandKeyError) => {
        switch (keyType) {
            case EBroadbandKeyError.UNAVAILABLE:
                return {
                    title: undefined,
                    message: t("broadband.unavailable.message"),
                    helper: undefined,
                };
            case EBroadbandKeyError.DEFAULT:
            default:
                return {
                    title: t("broadband.error.title"),
                    message: t("broadband.error.message"),
                    helper: t("broadband.error.helper"),
                };
        }
    };

    const { title, message, helper } = getTranslationKeys(broadbandKeyTranslation);

    return (
        <Grid container spacing={2}>
            {title && (
                <Grid item xs={12}>
                    <Typography className={classes.errorTitle} variant="normal">
                        {title}
                    </Typography>
                </Grid>
            )}
            <Grid container item spacing={2} xs={12}>
                {(message ?? helper) && (
                    <Grid className={classes.messageContainer} item md={8} xs={12}>
                        {message && (
                            <Typography className={classes.errorMessage} variant="small">
                                {message}
                            </Typography>
                        )}
                        {helper && (
                            <Typography className={classes.errorMessage} variant="small">
                                {helper}
                            </Typography>
                        )}
                    </Grid>
                )}
            </Grid>
            {remove && (
                <Grid className={classes.removeButtonContainer} md={4} xs={12}>
                    <LabeledButton labelText={t("broadband.remove")} onClick={onRemove}>
                        {t("broadband.remove")}
                    </LabeledButton>
                </Grid>
            )}
        </Grid>
    );
};
